import OnlineOnboardingBanner from './online-onboarding-banner';

export default OnlineOnboardingBanner;
